import { Avatar, Box, Button, Typography } from "@mui/material";
import { stringAvatar } from "../../../utils";
import { useStyles } from "../styles";

export const SelectedListCard = ({ data = {}, onRemove = () => false }) => {
    const classes = useStyles();
    return (
        <Box className={classes.selectedListCardRoot} display="flex" alignItems="center">
            <Box>
                <Avatar sx={{ borderRadius: "8px !important" }} src={data?.url} variant="square" {...stringAvatar(data?.label)} />

            </Box>
            <Box flexGrow={1} marginInlineStart="12px">
                <Typography className={classes.btnTitle}>{data?.label}</Typography>
                <Typography className={classes.email}>{data?.label1}</Typography>
            </Box>
            <Box>
                <Button
                    sx={{
                        '&:hover': {
                            background: "white"
                        }
                    }}
                    color="error" onClick={onRemove}>Remove</Button>
            </Box>
        </Box>
    )

}